import { render, staticRenderFns } from "./IyzicoPay.vue?vue&type=template&id=e031fe04"
import script from "./IyzicoPay.vue?vue&type=script&lang=js"
export * from "./IyzicoPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports